import axios from "axios"

import { store } from "../store"

export const getUri = () => {
   var url = window.location.host.split('.')

   let domain = (url[0].includes('localhost')) ? 'ingealimentos_api.test' : 'api.ingealimento.com'
   // const domain = 'api.ingealimento.com'
   
   return `https://${domain}`
}

export const getDomain = () => {
   var uri = getUri()
   
   return `${uri}/api`
}

/*
 * Instancia con el servicio principal del backend
 */
const ingealimentosApi = (customContentType = null) => {
   const state = store.getState();
   const authToken = state.auth.token;

   return axios.create({
      baseURL: getDomain(),
      timeout: 60000,
      headers: {
         Authorization: `Bearer ${authToken}`,
         "Content-Type": !customContentType ? "application/json; charset=UTF-8" : customContentType,
      }
   });
};

export default ingealimentosApi;
